import countries from './countries.de';

export default
{
    form_title: 'Spenden',
    form_back: 'Zurück zu den Videos',
    form_transfer: 'Banküberweisung',
    form_description: 'Sie haben hier die Möglichkeit mit Kreditkarte, Paypal, TWINT oder Banküberweisung Spenden zu tätigen.',
    form_payment_text: 'Vielen Dank für Ihre Spende!',
    amount: 'Betrag',
    currency: 'Währung',
    gender: 'Anrede',
    gender_m: 'Herr',
    gender_f: 'Frau',
    firstname: 'Vorname',
    lastname: 'Nachname',
    address: 'Adresse',
    email: 'Email',
    zip_code: 'PLZ',
    city: 'Stadt',
    country: 'Land',
    send: 'Senden',
    once: 'Einmalig',
    monthly: 'Monatlich',
    yearly: 'Jährlich',
    countries
}